import { ComponentProps } from 'react';
import { Box, Typography } from '@mui/material';

const FormInputFormat = ({
  children,
  description,
  flexGrow,
  label,
}: {
  children: React.ReactNode;
  description: string;
  flexGrow?: ComponentProps<typeof Box>['flexGrow'];
  label?: React.ReactNode;
}) => {
  return (
    <Box display='flex' flexDirection='column' flexGrow={flexGrow}>
      <Typography sx={{ mb: '2px' }} variant='font16Bold'>
        {label}
      </Typography>
      <Typography
        sx={{ color: theme => theme.palette.colors.grey[600], mb: '14px' }}
        variant='font12'
      >
        {description}
      </Typography>
      {children}
    </Box>
  );
};

export default FormInputFormat;
